import { Component, OnInit, Input } from '@angular/core';
import { PcgTableColumn } from '../../pcg-table-column.interface';

@Component({
    selector: 'pcg-button-hide-show',
    templateUrl: './button-hide-show.component.html',
    styleUrls: ['./button-hide-show.component.scss'],
    standalone: false
})
export class ButtonHideShowComponent implements OnInit {

	@Input() columnDefs: Map<string, PcgTableColumn>;

	colVisActive = false;

	getColDefs = () => Array.from(this.columnDefs.keys());

	constructor() { }

	ngOnInit() {
		this.columnDefs.forEach((value, key) => {
			if (value.isVisible !== false) {
				value.isVisible = true;
			}
		});
	}

}
